export const NULL_VERSION = { versionString: "0.0.1 Null Version" };

export class VersionStringBuilder {
  private versionString: string;

  constructor() {
    this.setVersionString(NULL_VERSION.versionString);
  }

  public readVersionStringFromEnvVariable(): any {
    try {
      return ENV_VERSION_JSON_OBJECT;
    } catch (e) {
      if (e instanceof ReferenceError) {
        return NULL_VERSION;
      }
    }
  }

  public build(): string {
    const localVersion = this.readVersionStringFromEnvVariable();
    this.setVersionString(localVersion.versionString);
    return localVersion.versionString;
  }

  public getVersionString(): string {
    return this.versionString;
  }

  public setVersionString(versionString: string): void {
    this.versionString = versionString;
  }
}
